import { API_SUCCESS, API_PENDING, API_FAILURE, RESET_INITIAL_STATE } from '@/constants/Actions'

export type DashboardState = {
  loading: boolean
  error: boolean
  errorType: string
  errorMessage: string
  success: boolean
  successMessage: string
}

export const dashboardInitialState: DashboardState = {
  loading: true,
  error: false,
  errorType: '',
  errorMessage: '',
  success: false,
  successMessage: '',
}

export type DashboardAction =
  | { type: typeof API_PENDING }
  | { type: typeof API_FAILURE; payload: { type: string; message: string } }
  | { type: typeof API_SUCCESS; payload: { message: string } }
  | { type: typeof RESET_INITIAL_STATE }

export const dashboardReducer = (
  state: DashboardState,
  action: DashboardAction,
): DashboardState => {
  const { type } = action

  switch (type) {
    case API_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
        errorType: '',
        errorMessage: '',
        success: false,
        successMessage: '',
      }
    case API_FAILURE:
      if ('payload' in action) {
        return {
          ...state,
          loading: false,
          error: true,
          errorType: action.payload.type,
          errorMessage: action.payload.message,
        }
      }
      return state
    case API_SUCCESS:
      if ('payload' in action) {
        return {
          ...state,
          loading: false,
          success: true,
          successMessage: action.payload.message,
        }
      }
      return state 
    case RESET_INITIAL_STATE:
      return {
        ...state,
        loading: false,
        error: false,
        success: false,
        successMessage: '',
        errorMessage: '',
      }
    default:
      return state
  }
}

export const dashboardActions = {
  submitTest:
    (id: any) => async (dispatch: (action: DashboardAction) => void) => {
      dispatch({ type: API_PENDING })
      try {
        //Call api here
        alert(`${id} submit triggered!`)

        dispatch({
          type: API_SUCCESS,
          payload: { message: 'Submit successfully' },
        })
      } catch (error) {
        dispatch({
          type: API_FAILURE,
          payload: { type: 'API_ERROR', message: 'Failed to submit' },
        })
      }
    },
}
